import React from 'react';
import styled from 'styled-components';

export const CardFooter : React.FunctionComponent<{className?: string}> = ({ children, className }) =>
{
    return (
        <Container className={className}>{children}</Container>
    );
};

const Container = styled.div`
    padding-left: 60px;
    padding-right: 60px;
    position: absolute;
    bottom: 0;
    margin-bottom: 50px;
`;